/**
 * Private modules
 */
const {
  amount,
  createQueryComponent,
  customerId,
  customerSystemTicketNumberPluginId,
  expectedAmount,
  number,
  objectId,
  objectIds,
  systemGameCategoryId,
  systemGameTypeId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  CUSTOMER_DEALER_EAT_LIMITS_FINAL_BY_SYSTEM_GAME_TYPE_ID,
  CUSTOMER_DEALER_EAT_LIMITS_OVERRIDE_BY_SYSTEM_GAME_TYPE_ID,
  DEFAULT,
} = require('../../scopes');

module.exports = {
  deleteCustomerDealerEatLimitsBySystemGameTypeId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerDealerEatLimitsBySystemGameTypeId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
      query: createQueryComponent([
        CUSTOMER_DEALER_EAT_LIMITS_FINAL_BY_SYSTEM_GAME_TYPE_ID,
        CUSTOMER_DEALER_EAT_LIMITS_OVERRIDE_BY_SYSTEM_GAME_TYPE_ID,
        DEFAULT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  saveCustomerDealerEatLimitsBySystemGameTypeId: {
    properties: {
      body: {
        properties: {
          customerSystemTicketNumberPluginId,
          elements: {
            items: {
              properties: {
                amount: {
                  ...amount,
                  minimum: 0,
                },
                systemGameCategoryId,
              },
              required: [
                'amount',
                'systemGameCategoryId',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
          number,
        },
        required: [
          'customerSystemTicketNumberPluginId',
          'elements',
          'number',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  updateCustomerDealerEatLimitsBySystemGameTypeId: {
    properties: {
      body: {
        properties: {
          elements: {
            items: {
              properties: {
                amount: {
                  ...amount,
                  minimum: 0,
                },
                expectedAmount: {
                  ...expectedAmount,
                  minimum: 0,
                },
                objectId,
              },
              required: [
                'amount',
                'objectId',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: ['elements'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
